
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllYoutubeCmsEstimateAssets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"month"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cmsChannelId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allYoutubeCmsEstimateAssets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"month"},"value":{"kind":"Variable","name":{"kind":"Name","value":"month"}}},{"kind":"Argument","name":{"kind":"Name","value":"keyword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}}},{"kind":"Argument","name":{"kind":"Name","value":"cmsChannelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmsChannelId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assetName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cmsChannelId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ownerChannelId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ownerChannelName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"partnerRevenue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shareRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shareCreator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isOwner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"belongMultipleChannels"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taRevenue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taProfit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taShareRate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rpm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taRpm"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"allYoutubeCmsEstimateAssetsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"keyword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keyword"}}},{"kind":"Argument","name":{"kind":"Name","value":"cmsChannelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmsChannelId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalNumber"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":659}};
    doc.loc.source = {"body":"query AllYoutubeCmsEstimateAssets($offset: Int!, $limit: Int!, $month: Date, $keyword: String, $cmsChannelId: Int) {\n  allYoutubeCmsEstimateAssets(\n    offset: $offset\n    limit: $limit\n    month: $month\n    keyword: $keyword\n    cmsChannelId: $cmsChannelId\n  ) {\n    id\n    assetId\n    assetName\n    cmsChannelId\n    ownerChannelId\n    ownerChannelName\n    partnerRevenue\n    shareRate\n    shareCreator\n    profit\n    currency\n    lastUpdatedDate\n    isOwner\n    belongMultipleChannels\n    taRevenue\n    taProfit\n    taShareRate\n    rpm\n    taRpm\n  }\n  allYoutubeCmsEstimateAssetsCount(keyword: $keyword, cmsChannelId: $cmsChannelId) {\n    totalNumber\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AllYoutubeCmsEstimateAssets"] = oneQuery(doc, "AllYoutubeCmsEstimateAssets");
        
